import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        root: css`
            ${common.fullContainer};
            display: flex;
        `,
        main: css`
            ${custom.dashBoardRoot};
            display: flex;
            flex-grow: 1;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
        `,
        button: css`
            ${custom.button};
            padding: 0;
        `,
    }
}

export default styles
